module.exports = __webpack_public_path__ + "static/media/fb.e789912e.png";